<template>
    <header class="head-bar">
        <div class="container">
            <div class="mobile-icon d-block d-lg-none">
                <button @click="showWebMenu()"><font-awesome-icon :icon="['fas', 'bars']" /></button>
            </div>
            <router-link :to="'/' + $route.params.lang" class="logo d-none d-lg-block"><img src="@/assets/logo.png" alt="ProbPlus Logo" title="ProbPlus Logo" /></router-link>
            <nav>
                <div class="top-menu d-none d-lg-block">
                    <router-link :to="'/' + $route.params.lang">{{ $PPlusEngine.getDictionary($route.params.lang, 'หน้าหลัก', 'Home') }}</router-link>
                    <router-link :to="'/' + $route.params.lang + '/course'">{{ $PPlusEngine.getDictionary($route.params.lang, 'คอร์สเรียน', 'Courses') }}</router-link>
                    <router-link :to="'/' + $route.params.lang + '/exam'">{{ $PPlusEngine.getDictionary($route.params.lang, 'สอบวัดผล', 'Exam') }}</router-link>
                    <router-link :to="'/' + $route.params.lang + '/payment'">{{ $PPlusEngine.getDictionary($route.params.lang, 'การชำระเงิน', 'Payment') }}</router-link>
                    <span>|</span>
                </div>
                <template v-if="$PPlusEngine.IsAuthen">
                    <button class="outline" @click="showUserMenu()">{{ fields.user.firstName }}</button>
                </template>
                <template v-if="!$PPlusEngine.IsAuthen">
                    <button class="outline" @click="showLoginModal()">{{ $PPlusEngine.getDictionary($route.params.lang, 'เข้าสู่ระบบ', 'Sign In') }}</button>
                    <button class="fill" @click="showRegisterModal()">{{ $PPlusEngine.getDictionary($route.params.lang, 'ลงทะเบียน', 'Sign Up') }}</button>
                </template>
                <button class="language" @click="showLanguage()">
                    <img :src="require('@/assets/flag-' + $route.params.lang + '.png')" alt="Language" title="Language" />
                </button>
			</nav>
        </div>

        <ModalWebMenu :isDisplay="isShowWebMenu" @hideWebMenu="hideWebMenu()" />
        <ModalUserMenu :isDisplay="isShowUserMenu" :fields="fields" @hideUserMenu="hideUserMenu()" />
    </header>
</template>

<script>
import ModalWebMenu from '@/components/Modal/WebMenu';
import ModalUserMenu from '@/components/Modal/UserMenu';

export default {
    components: {
        ModalWebMenu,
        ModalUserMenu
    },
    props: {
        fields: Object
    },
    created() {
    },
    data() {
        return {
            isShowWebMenu: false,
            isShowUserMenu: false,
        }
    },
    methods: {
        showLanguage() {
            this.$PPlusModal.language();
        },
        showLoginModal() {
            this.$PPlusModal.login();
        },
        showRegisterModal() {
            this.$PPlusModal.register();
        },
        showWebMenu() {
            this.isShowWebMenu = true;
        },
        hideWebMenu() {
            this.isShowWebMenu = false;
        },
        showUserMenu() {
            this.isShowUserMenu = true;
        },
        hideUserMenu() {
            this.isShowUserMenu = false;
        },
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.head-bar {
    background: #fff;
    border-bottom: 1px solid #f2f2f2;
    padding: 15px 0;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;

    .logo {
        float: left;

        @media only screen and (max-width: $screenMedium) {
            padding-top: 5px;
        }

        img {
            display: block;
            height: 40px;

            @media only screen and (max-width: $screenMedium) {
                height: 30px;
            }
        }
    }

    .mobile-icon {
        float: left;
        padding-top: 7px;
        margin-right: 10px;

        button {
            font-size: 26px;
            line-height: 26px;
            color: #777;
            padding: 0;
            background: #fff;
            border: none;
            outline: none;
        }
    }

    nav {
        float: right;
        text-align: right;

        .top-menu {
            float: left;
            padding-top: 7px;
        }

        span {
            color: #ccc;
            margin: 0 20px 0 10px;
        }

        a, button {
            color: #333;
            background: #fff;
            font-size: 15px;
            margin: 0 10px;
            border: none;
            border-bottom: 1px solid transparent;

            &.active {
                color: #777;
                padding-bottom: 3px;
                border-bottom-color: $mainColor;
            }

            &:hover {
                padding-bottom: 3px;
                border-bottom-color: $mainColor;
                text-decoration: none;
            }

            &.outline {
                margin: 0 0 0 3px;
                padding: 8px 13px;
                border: 1px solid $mainColor;
                color: $mainColor;

                &:hover {
                    opacity: 0.8;
                }

                @media only screen and (max-width: $screenExtraSmall) {
                    padding: 8px;
                }
            }

            &.fill {
                margin: 0 0 0 3px;
                padding: 8px 13px;
                color: #fff;
                border: 1px solid $mainColor;
                background: $mainColor;

                &:hover {
                    opacity: 0.8;
                }

                @media only screen and (max-width: $screenExtraSmall) {
                    padding: 8px;
                }
            }

            &.language {
                background :none;
                border-bottom: none;
                outline: none;
                margin: 0;
                padding-left: 10px;
                vertical-align: text-bottom;

                &:hover {
                    border-bottom: none;
                }

                img {
                    display: block;
                    width: 30px;
                }
            }
        }
    }
}
</style>